import { Box, Divider, Stack, Typography } from '@mui/material';
import React, { type FC, useEffect } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';

import styles from './EventList.module.scss';
import EventsListItem from './EventsListItem.js';
import { useStreamPreferences } from '../../api/index.js';
import { useEvents } from '../../utils/index.js';
import { EventMessageCategory } from '../../utils/use-events.js';
import Loading from '../Loading.js';

interface EventsListProps {
  setActiveEventsCount: (value: number) => void;
}

const EventsList: FC<EventsListProps> = ({ setActiveEventsCount }) => {
  // TODO: this needs to be redone. list is not updating on stream preference changes + is stuck on Loading when no events available.
  const {
    data: streamPreferences,
    refetch: refetchStreamPreferences,
    isLoading: isLoadingStreamPreferences,
  } = useStreamPreferences();
  const selectedPatients = streamPreferences?.patients?.filter(({ selected }) => selected) || [];
  const patientIds = selectedPatients.map(({ id }) => id);
  const {
    activeEvents,
    upcomingEvents,
    isLoading: isLoadingEvents,
  } = useEvents(patientIds,
    async ({ data: { category } }) => {
    console.log(category);
      if (category === EventMessageCategory.MATCHING_UPDATED) {
        await refetchStreamPreferences();
      }
    },
  );

  useEffect(() => {
    setActiveEventsCount(activeEvents.length);
  }, [activeEvents, setActiveEventsCount]);
  const isLoading = isLoadingStreamPreferences || isLoadingEvents;

  return (
    <Stack justifyContent={'center'} sx={{ p: 1, flexGrow: 1 }} spacing={1}>
      <Typography variant={'h6'}>Urgent duties</Typography>
      {isLoading ? (
        <Loading />
      ) : (
        <Box sx={{ height: '100%' }}>
          <AutoSizer>
            {({ height, width }: { height: number; width: number }) => (
              <FixedSizeList
                className={styles['no-scrollbars']}
                height={height}
                width={width}
                itemSize={64}
                itemData={activeEvents}
                itemCount={activeEvents.length}
                overscanCount={5}
              >
                {EventsListItem}
              </FixedSizeList>
            )}
          </AutoSizer>
        </Box>
      )}
      <Divider />
      <Typography>Upcoming tasks</Typography>
      {isLoading ? (
        <Loading />
      ) : (
        <Box sx={{ height: '100%' }}>
          <AutoSizer>
            {({ height, width }: { height: number; width: number }) => (
              <FixedSizeList
                className={styles['no-scrollbars']}
                height={height}
                width={width}
                itemSize={64}
                itemData={upcomingEvents}
                itemCount={upcomingEvents.length}
                overscanCount={5}
              >
                {EventsListItem}
              </FixedSizeList>
            )}
          </AutoSizer>
        </Box>
      )}
    </Stack>
  );
};

export default EventsList;
